import { TreeNode } from "./types";

export function getExpandedFromSearch(
  nodes: TreeNode[],
  query: string
): Record<string, boolean> {
  const expanded: Record<string, boolean> = {};

  if (!query.trim()) return expanded;

  const q = query.toLowerCase();

  const walk = (node: TreeNode): boolean => {
    const selfMatch = node.label
      .toLowerCase()
      .includes(q);

    let childMatch = false;

    if (node.children) {
      childMatch = node.children
        .map(walk)
        .some(Boolean);
    }

    // if any child matches → expand this node
    if (childMatch) {
      expanded[node.id] = true;
    }

    // optional: also expand self-matching nodes with children
    if (selfMatch && node.children?.length) {
      expanded[node.id] = true;
    }

    return selfMatch || childMatch;
  };

  nodes.forEach(walk);

  return expanded;
}